import React, { Component } from 'react';
import { Link } from "react-router-dom";

class List extends Component
{
	constructor ( props )
	{
		super( props );
		this.props = props;
	}

	renderItems = () =>
	{
		return this.props.list.map( ( item, key ) => (

			<div key={key} className="book-cards">
				<Link
					to={{
						pathname : item.route_path ? `/course/detail/${item.route_path}` : `/course/${item.id}`
					}}
				>
					<div className="book-card">
						<img className="product-img" src={item.image} alt=""/>
						<p className="continue-discussion-title">
							{item.name}
						</p>
						<p className="book-category">
							{item.count}  جلسه
						</p>
					</div>
				</Link>
			</div>

		) );
	};

	render ()
	{
		return (
			<section className="books">
				<h2 className="books-title">
					{this.props.title}
				</h2>
				<div className="book-div card-group card-group-scroll-learn no-scrollbar">
					{this.renderItems()}
				</div>
			</section>
		);
	}
}

export default List;
